import React, { useState } from 'react';
import { Popper, Sheet, Text, useIsMobile } from '@amzn/storm-ui';
import { Button, TextButton } from './styles';
import { ACTION_STATE, BUTTON_TYPE, PopoverType } from '../types';
import { usePageHeaderBundle } from 'src/providers/PantherLocalizationProvider';

const Trigger = ({
  id,
  isDisabled,
  mobileOnClick,
  buttonType,
  label,
  ariaLabel,
}) =>
  buttonType === BUTTON_TYPE.LINK ? (
    <TextButton
      id={id}
      disabled={isDisabled}
      onClick={mobileOnClick}
      aria-label={ariaLabel}
    >
      {label}
    </TextButton>
  ) : (
    <Button
      id={id}
      disabled={isDisabled}
      onClick={mobileOnClick}
      aria-label={ariaLabel}
    >
      {label}
    </Button>
  );

const popoverContent = (content, contentType) =>
  content &&
  (contentType === 'HTML' ? (
    <div dangerouslySetInnerHTML={{ __html: content }} />
  ) : (
    <div>{content}</div>
  ));
const ActionsPopoverMobile: React.VFC<PopoverType> = ({
  id,
  label,
  state,
  content,
  contentType,
  buttonType,
  ariaLabel,
}) => {
  const bundle = usePageHeaderBundle();
  const [isSheetOpen, setSheetOpen] = useState(false);
  return (
    <>
      <Sheet
        isOpen={isSheetOpen}
        onClose={() => setSheetOpen(false)}
        closeButton={{
          type: 'icon',
          label: bundle.getMessage(
            'page-header-popover-close-button-aria-label',
          ),
        }}
        side="bottom"
        type="light"
      >
        <Text>{popoverContent(content, contentType)}</Text>
      </Sheet>
      <Trigger
        id={id}
        isDisabled={state === ACTION_STATE.DISABLED}
        mobileOnClick={() => setSheetOpen(true)}
        buttonType={buttonType}
        label={label}
        ariaLabel={ariaLabel}
      />
    </>
  );
};

const ActionsPopoverDesktop: React.VFC<PopoverType> = ({
  id,
  label,
  state,
  content,
  contentType,
  buttonType,
  tooltipPosition,
  ariaLabel,
}) => {
  const bundle = usePageHeaderBundle();
  const [active, setActive] = useState(false);
  const isDisabled = state === ACTION_STATE.DISABLED;
  return (
    <Popper
      position={tooltipPosition}
      align="start"
      isOpen={active}
      onClick={() => {
        if (!isDisabled) {
          setActive(!active);
        }
      }}
      trigger={
        <Trigger
          id={id}
          isDisabled={isDisabled}
          mobileOnClick={undefined}
          buttonType={buttonType}
          label={label}
          ariaLabel={ariaLabel}
        />
      }
      autoFocus={true}
      withCloseButton={true}
      closeButtonLabel={bundle.getMessage(
        'page-header-popover-close-button-aria-label',
      )}
      onCloseButtonClick={() => setActive(false)}
    >
      <Text>{popoverContent(content, contentType)}</Text>
    </Popper>
  );
};

export const ActionsPopover: React.VFC<PopoverType> = (props) =>
  useIsMobile() ? (
    <ActionsPopoverMobile {...props} />
  ) : (
    <ActionsPopoverDesktop {...props} />
  );
